import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { subscribeApiLoading } from "../lib/api";

/** Hook — returns true when any axios request is in flight. */
export function useApiLoading() {
    const [active, setActive] = useState(0);
    useEffect(() => subscribeApiLoading(setActive), []);
    return active > 0;
}

/** tbody row that says "Loading…" with a spinner. */
export function LoadingRow({ colSpan, message = "Loading data…" }) {
    return (
        <tr>
            <td colSpan={colSpan} className="p-12 text-center">
                <div className="inline-flex items-center gap-2 text-zinc-500 text-sm" data-testid="loading-row">
                    <Loader2 className="h-4 w-4 wl-accent-text animate-spin" />
                    <span>{message}</span>
                </div>
            </td>
        </tr>
    );
}

/** Inline spinner badge used near titles or filter rows. */
export function LoadingBadge({ label = "Loading…" }) {
    return (
        <span className="inline-flex items-center gap-1.5 text-xs text-zinc-500" data-testid="loading-badge">
            <Loader2 className="h-3 w-3 wl-accent-text animate-spin" />
            <span>{label}</span>
        </span>
    );
}
